import React, { PropsWithChildren } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';

export function FormContainer<T>({
  children,
  onSubmit,
  isSubmitting,
  noReset = false,
  disableButtons = false,
  additionalButtons,
  onReset,
  ...props
}: PropsWithChildren<{
  onSubmit?: SubmitHandler<T>;
  isSubmitting: boolean;
  noReset?: boolean;
  disableButtons?: boolean;
  additionalButtons?: React.ReactNode;
  onReset?: () => void;
}>) {
  const { handleSubmit, reset } = useFormContext<T>();
  return (
    <form className={'ui form'} onSubmit={handleSubmit(onSubmit)} onReset={() => {
      reset();
        if(onReset) {
          onReset();
        }
      }} 
      noValidate {...props}>
      <div className={'ui grid divided stackable'}>
        {children}
        <div className="fields" style={{ paddingBottom: '10px' }}>
          <button className={`ui button primary`} type="submit" disabled={isSubmitting || disableButtons}>
            <span>{'Submit'}</span>
          </button>
          {!noReset && (
            <button className={`ui button secondary`} type={'reset'} disabled={isSubmitting || disableButtons}>
              <span>Reset</span>
            </button>
          )}
          {additionalButtons}
          {isSubmitting && <span className="ui active centered inline loader" />}
        </div>
      </div>
    </form>
  );
}
